import { render, staticRenderFns } from "./VActionsGroup.vue?vue&type=template&id=11167395&functional=true&"
import script from "./VActionsGroup.vue?vue&type=script&lang=js&"
export * from "./VActionsGroup.vue?vue&type=script&lang=js&"
import style0 from "./VActionsGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports